import styled from "styled-components";

export const _Description = styled.span`
  display: block;
  text-align: left;
  font-size: 16px;
  font-weight: 300;
  color: #333333;
  
  @media (min-width: 768px) {
    text-align: center;
    font-size: 18px;
  }
  
  @media (min-width: 1024px) {
    text-align: center;
    font-size: 20px;
  }
`;

export const NavigateButton = styled.button`
  width: 100%;
  margin: 10px 0px 0px 0px;
  white-space: nowrap;

  &::after {
    font-size: 20px;
    display: inline-block;
    vertical-align: middle;
    margin-left: 4px;
    content: "➝";
  }
`;

export const _ChangeSeasonInfo = styled.p`
  font-size: 14px;
`;

export const _ReadMore = styled.span`
  margin: 0px 10px;
  font-size: 16px;
`;

export const _SubDescription = styled.span`
  text-align: left;
  font-size: 18px;
  display: inline-block;
  margin: 10px 0px;
`;



export const _SeasonName = styled.h4`
  margin-top: '5px';
`;

export const _SeasonInfoShortDescription = styled.div`
  display: none;
  margin: 10px 0px;
  font-size: 12px;

  @media (min-width: 480px) {
    display: block;
  }
`;
